// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container {
  margin: 1rem;
}

.items {
  margin-bottom: 1rem;
  justify-content: space-between;
}

p{
  margin-bottom: 0 !important;
}

*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}
:root {
  --popSemiBold : ;
}

.dashboard{
  width: 100%;
  background-color: #F2F2F7;
  padding: 16px;
  min-height: 100vh;
}nav{
  background-color: white;
  width: 100%;
  border-radius: 30px;
  display: flex;
  justify-content: space-between;
}
.logo{
  display: flex;
  align-items: center;
}
.logo-img{
  background-color: rgba(69, 194, 105, .1);
  border-radius: 32px;
  margin: 4px;
}
.logo-img img{
  padding: 4px 9px;
}
.logo-name a{
  display: inline-block;
  text-decoration: none;
  color: black;
  font-weight: bold;
  font-size: 22px;
  margin-left: 10px;
}


.admin-img {
  display: flex;
    width: 40px;
    height: 40px;
    background: #000;
    color: #fff;
    font-size: 25px;
    justify-content: center;
    align-items: end;
border-radius: 100px;
}

.admin-img img{
  width: 50px;
}
.admin-info{
  display: flex;
  align-items: center;
}

.admin-name{
  padding: 0 10px;
}

.admin-dd{
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #E5E5EA;
  border-radius: 50%;
  margin-right: 5px;
  cursor: pointer;
}


.main{
  display: flex;
  width: 100%;
  padding: 16px 0 0;
  gap: 16px;
}


.sidebar{
  background-color: white;
  padding: 0px 16px;
  padding-bottom: 16px;
  border-radius: 20px;
  margin-bottom: 16px;
}
.side-head{
  padding: 10px 0;
  margin-left: 10px;
}
.xdr-box{
  display: flex;
  justify-content: space-between;
  padding: 8px;
  border-radius: 40px;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.xdr-bg1{
  background-color: #3e8bf71f;
  transition: all 0.6s;
}
.xdr-bg2{
  background-color: #d1a2f82e;
  transition: all 0.6s;
}
.xdr-bg3{
  background-color: #ffa2a224;
  transition: all 0.6s;
}
.xdr-bg4{
  background-color: #ffa2bf2e;
  transition: all 0.6s;
}
.xdr-circle{
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 5px;
}
.xdr-circle-bg1{
  background-color: #3E8CF7;
}
.xdr-circle-bg2{
  background-color: #D1A2F9;
}
.xdr-circle-bg3{
  background-color: #FFA2A2;
}
.xdr-circle-bg4{
  background-color: #FFA2C0;
}
.xdr-name p:nth-child(1){
  color: #11142d;
    margin-top: 0;
    margin-bottom: 0;
    font-family: Poppins, sans-serif;
    font-weight: 700;
    font-size: 18px;
}

.heading-2 {
  border-radius: var(--radius--r-40);
  color: var(--text-black);
  background-color: rgba(0, 0, 0, 0);
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 8px;
  padding-right: 8px;
  font-family: Poppins, sans-serif;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
}

.xdr-name{
  padding-left: 5px;
}

.user-head{
  padding-top: 20px;
}
.user-management{
  display: flex;
  align-items: center;
  background-color: #F2F2F7;
  border-radius: 30px;
  padding: 5px;
  position: relative;
  margin-top: 10px;
}
.user-icon{
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  margin-right: 5px;
  cursor: pointer;
}
.user-betch{
  position: absolute;
  right: 10px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.148);
  padding: 5px;
}
.setting{
  background-color: white;
  border-radius: 30px;
  display: flex;
  align-items: center;
  padding: 5px;
  margin: 0 15px;
}
.setting-icon{
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F2F2F7;
  border-radius: 50%;
  margin-right: 5px;
  cursor: pointer;
}


.main-pannel{
  background-color: white;
  padding: 15px;
  border-radius: 20px;
  flex: 3 1;
  position: relative;
}
.xdr-nav{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.xdr-info{
  display: flex;
  align-items: center;
}
.xdr-info p{
  padding-left: 10px;
}

.xdr-architecture.close{
  background-color: #dd3731;
}

.xdr-architecture.close .xdr-arc-icon{
  width: 50px;
  height: 50px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.diagramImg{
  padding-top: 10px;
  width: 1000px !important;
}

.xdr-architecture.close p{
  color: #ffffff;
}

.xdr-architecture{
  background-color: #F2F2F7;
  border-radius: 32px;
  display: flex;
  align-items: center;
  padding: 5px;
}
.xdr-architecture p{
  padding: 0 10px;
}
.xdr-arc-icon{
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
}


.xdr-row{
  display: flex;
  width: 100%;
  gap: 15px;
  margin-bottom: 15px;
}
.xdr-content-box{
  width:33.33%;
  border-radius: 30px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.xdr-content-icon{
  width: 75px;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  margin-right: 5px;
  cursor: pointer;
}
.xdr-card-info{
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  position: relative;
}

.xdr-title{
  display: flex;
  align-items: center;
  padding: 10px;
}
.xdr-title p{
font-size: 20px;
font-weight: bold;
margin-left: 10px;
}
.xdr-arrow{
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff75;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  right: 0;
}
.xdr-content-text{
  padding: 20px 10px;
  display: flex;
  position: relative;
}
.xdr-info-btn{
  position: absolute;
  right: 5px;
  bottom: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.148);
  border-radius: 50%;
  cursor: pointer;
}

.xdr-content-text p{
  width: 90%;
}

.coming-soon{
  position: fixed;
  bottom: 15px;
  right: 15px;
}


.box0-color{
  background-color: #3e8bf729;
}
.box1-color{
  background-color: #F6ECFD;
}
.box2-color{
  background-color: #FFE8E8;
}
.box3-color{
  background-color: #FFE8EF;
}


#xdr-row1-1{
  display: none;
}
#xdr-row2-1{
  display: none;
}
#xdr-row2-2{
  display: none;
}
#xdr-row3-1{
  display: none;
}

#xdr-logo-2{
  display: none;
}
#xdr-logo-3{
  display: none;
}
#xdr-logo-4{
  display: none;
}

#xdr-para-2{
  display: none;
}
#xdr-para-3{
  display: none;
}
#xdr-para-4{
  display: none;
}


.hamburger{
  width: 50px;
  height: 50px;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
  display: none;
}

@media screen and (max-width:992px) {
  .xdr-content-box{
      width: 100%;
  }
  .xdr-row{
      flex-direction: column;
  }
  .main-pannel{
      padding-bottom: 200px;
  }
  .user-betch {
      right: -4px;
      top: -8px;
  }

}

@media screen and (max-width:769px) {
  .xdr-content-box{
      width: 100%;
  }
  .xdr-row{
      flex-direction: column;
  }
  .xdr-info p {
      padding-top: 10px;
      font-size: 12px;
        padding-left: 0;
  }
  .xdr-info{
      align-items: start;
      flex-direction: column;
    
  }
  .xdr-architecture p{
      display: none;
  } 
  .xdr-arc-icon{
      margin-right: 0;
  }
  .user-betch {
      right: -4px;
      top: -8px;
}
}
@media screen and (max-width:500px) {
.main-pannel{
      padding-bottom: 0;
}

.ham-menu {
  display: flex !important;
  width: 125px;
  justify-content: space-evenly;
}

.admin-name{
  display: none;
}
.admin-img{
  margin: 0 10px;
}
.main{
  flex-direction: column;
}
.sidebar-2{
  display: none;
}
.setting{
 margin-bottom: 20px;
}
.main-pannel{
  margin-left: 0;
}
.xdr-arc-icon{
  margin-right:0;
}
.xdr-architecture p{
  display: none;
}
.xdr-info{
  flex-direction: column;
}
.coming-soon{
  display: none;
}
.hamburger{
  display: flex;
}
.sidebar-column{
  padding-top: 20px;
}

.set-hamburger-btn{
  display: flex !important;
}

.sidebar-1{
  display: none;
}

#close{
  display: none;
}

.xdr-content-text p{
  width: 90%;
}

#set-close{
  display: none;
}
}

@media screen and (max-width:375px) {
.admin-dd{
  display: none;
}
}

.ham-menu {
  display: none;
  width: 125px;
  justify-content: space-evenly;
}

.set-hamburger-btn {
  width: 50px;
  height: 50px;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
  display: none;
}

.logout-btn {
  z-index: 100;
  border-radius: var(--radius--r-40);
  cursor: pointer;
  background-color: #9de9b3;
  justify-content: flex-start;
  align-items: center;
  margin-left: 24px;
  margin-right: 24px;
  padding: 5px;
  display: none;
  position: absolute;
  top: auto;
  bottom: -86px;
  left: -32px;
  right: -12px;
}


.card-row-1 {
  margin-top: var(--padding--p-24);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  flex-flow: row;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-items: stretch;
  justify-items: stretch;
  display: grid;
}


@media screen and (min-width: 1280px) {
  .card-row-1 {
      grid-template-columns: 1fr 1fr 1fr;
  }
}

@media screen and (max-width: 991px) {
  .card-row-1 {
      grid-template-rows: auto auto;
      grid-template-columns: 1fr 1fr;
  }
  .sidebar-column{
    display: none;
  } 
}

@media screen and (max-width: 767px) {
  .card-row-1 {
      grid-template-rows: auto;
      grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB,CAAC;EACC,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,aAAa;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB,oBAAoB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;;AAGA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;IACZ,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;AACA,eAAe;AACf,iBAAiB;AACjB,iBAAiB;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;;AAGA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE;MACI,WAAW;EACf;EACA;MACI,sBAAsB;EAC1B;EACA;MACI,qBAAqB;EACzB;EACA;MACI,WAAW;MACX,SAAS;EACb;;AAEF;;AAEA;EACE;MACI,WAAW;EACf;EACA;MACI,sBAAsB;EAC1B;EACA;MACI,iBAAiB;MACjB,eAAe;QACb,eAAe;EACrB;EACA;MACI,kBAAkB;MAClB,sBAAsB;;EAE1B;EACA;MACI,aAAa;EACjB;EACA;MACI,eAAe;EACnB;EACA;MACI,WAAW;MACX,SAAS;AACf;AACA;AACA;AACA;MACM,iBAAiB;AACvB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;CACC,mBAAmB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;AACA;;AAEA;AACA;EACE,aAAa;AACf;AACA;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;AACf;;;AAGA;EACE;MACI,kCAAkC;EACtC;AACF;;AAEA;EACE;MACI,6BAA6B;MAC7B,8BAA8B;EAClC;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;MACI,wBAAwB;MACxB,0BAA0B;EAC9B;AACF","sourcesContent":["#container {\n  margin: 1rem;\n}\n\n.items {\n  margin-bottom: 1rem;\n  justify-content: space-between;\n}\n\np{\n  margin-bottom: 0 !important;\n}\n\n*{\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: \"Roboto\", sans-serif;\n}\n:root {\n  --popSemiBold : ;\n}\n\n.dashboard{\n  width: 100%;\n  background-color: #F2F2F7;\n  padding: 16px;\n  min-height: 100vh;\n}nav{\n  background-color: white;\n  width: 100%;\n  border-radius: 30px;\n  display: flex;\n  justify-content: space-between;\n}\n.logo{\n  display: flex;\n  align-items: center;\n}\n.logo-img{\n  background-color: rgba(69, 194, 105, .1);\n  border-radius: 32px;\n  margin: 4px;\n}\n.logo-img img{\n  padding: 4px 9px;\n}\n.logo-name a{\n  display: inline-block;\n  text-decoration: none;\n  color: black;\n  font-weight: bold;\n  font-size: 22px;\n  margin-left: 10px;\n}\n\n\n.admin-img {\n  display: flex;\n    width: 40px;\n    height: 40px;\n    background: #000;\n    color: #fff;\n    font-size: 25px;\n    justify-content: center;\n    align-items: end;\nborder-radius: 100px;\n}\n\n.admin-img img{\n  width: 50px;\n}\n.admin-info{\n  display: flex;\n  align-items: center;\n}\n\n.admin-name{\n  padding: 0 10px;\n}\n\n.admin-dd{\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #E5E5EA;\n  border-radius: 50%;\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n\n.main{\n  display: flex;\n  width: 100%;\n  padding: 16px 0 0;\n  gap: 16px;\n}\n\n\n.sidebar{\n  background-color: white;\n  padding: 0px 16px;\n  padding-bottom: 16px;\n  border-radius: 20px;\n  margin-bottom: 16px;\n}\n.side-head{\n  padding: 10px 0;\n  margin-left: 10px;\n}\n.xdr-box{\n  display: flex;\n  justify-content: space-between;\n  padding: 8px;\n  border-radius: 40px;\n  align-items: center;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n.xdr-bg1{\n  background-color: #3e8bf71f;\n  transition: all 0.6s;\n}\n.xdr-bg2{\n  background-color: #d1a2f82e;\n  transition: all 0.6s;\n}\n.xdr-bg3{\n  background-color: #ffa2a224;\n  transition: all 0.6s;\n}\n.xdr-bg4{\n  background-color: #ffa2bf2e;\n  transition: all 0.6s;\n}\n.xdr-circle{\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n.xdr-circle-bg1{\n  background-color: #3E8CF7;\n}\n.xdr-circle-bg2{\n  background-color: #D1A2F9;\n}\n.xdr-circle-bg3{\n  background-color: #FFA2A2;\n}\n.xdr-circle-bg4{\n  background-color: #FFA2C0;\n}\n.xdr-name p:nth-child(1){\n  color: #11142d;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-family: Poppins, sans-serif;\n    font-weight: 700;\n    font-size: 18px;\n}\n\n.heading-2 {\n  border-radius: var(--radius--r-40);\n  color: var(--text-black);\n  background-color: rgba(0, 0, 0, 0);\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-left: 8px;\n  padding-right: 8px;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.xdr-name{\n  padding-left: 5px;\n}\n\n.user-head{\n  padding-top: 20px;\n}\n.user-management{\n  display: flex;\n  align-items: center;\n  background-color: #F2F2F7;\n  border-radius: 30px;\n  padding: 5px;\n  position: relative;\n  margin-top: 10px;\n}\n.user-icon{\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 50%;\n  margin-right: 5px;\n  cursor: pointer;\n}\n.user-betch{\n  position: absolute;\n  right: 10px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.148);\n  padding: 5px;\n}\n.setting{\n  background-color: white;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  margin: 0 15px;\n}\n.setting-icon{\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #F2F2F7;\n  border-radius: 50%;\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n\n.main-pannel{\n  background-color: white;\n  padding: 15px;\n  border-radius: 20px;\n  flex: 3;\n  position: relative;\n}\n.xdr-nav{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.xdr-info{\n  display: flex;\n  align-items: center;\n}\n.xdr-info p{\n  padding-left: 10px;\n}\n\n.xdr-architecture.close{\n  background-color: #dd3731;\n}\n\n.xdr-architecture.close .xdr-arc-icon{\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.diagramImg{\n  padding-top: 10px;\n  width: 1000px !important;\n}\n\n.xdr-architecture.close p{\n  color: #ffffff;\n}\n\n.xdr-architecture{\n  background-color: #F2F2F7;\n  border-radius: 32px;\n  display: flex;\n  align-items: center;\n  padding: 5px;\n}\n.xdr-architecture p{\n  padding: 0 10px;\n}\n.xdr-arc-icon{\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n\n.xdr-row{\n  display: flex;\n  width: 100%;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n.xdr-content-box{\n  width:33.33%;\n  border-radius: 30px;\n  padding: 5px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.xdr-content-icon{\n  width: 75px;\n  height: 75px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 50%;\n  margin-right: 5px;\n  cursor: pointer;\n}\n.xdr-card-info{\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.xdr-title{\n  display: flex;\n  align-items: center;\n  padding: 10px;\n}\n.xdr-title p{\nfont-size: 20px;\nfont-weight: bold;\nmargin-left: 10px;\n}\n.xdr-arrow{\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff75;\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n}\n.xdr-content-text{\n  padding: 20px 10px;\n  display: flex;\n  position: relative;\n}\n.xdr-info-btn{\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.148);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.xdr-content-text p{\n  width: 90%;\n}\n\n.coming-soon{\n  position: fixed;\n  bottom: 15px;\n  right: 15px;\n}\n\n\n.box0-color{\n  background-color: #3e8bf729;\n}\n.box1-color{\n  background-color: #F6ECFD;\n}\n.box2-color{\n  background-color: #FFE8E8;\n}\n.box3-color{\n  background-color: #FFE8EF;\n}\n\n\n#xdr-row1-1{\n  display: none;\n}\n#xdr-row2-1{\n  display: none;\n}\n#xdr-row2-2{\n  display: none;\n}\n#xdr-row3-1{\n  display: none;\n}\n\n#xdr-logo-2{\n  display: none;\n}\n#xdr-logo-3{\n  display: none;\n}\n#xdr-logo-4{\n  display: none;\n}\n\n#xdr-para-2{\n  display: none;\n}\n#xdr-para-3{\n  display: none;\n}\n#xdr-para-4{\n  display: none;\n}\n\n\n.hamburger{\n  width: 50px;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  border-radius: 50%;\n  cursor: pointer;\n  display: none;\n}\n\n@media screen and (max-width:992px) {\n  .xdr-content-box{\n      width: 100%;\n  }\n  .xdr-row{\n      flex-direction: column;\n  }\n  .main-pannel{\n      padding-bottom: 200px;\n  }\n  .user-betch {\n      right: -4px;\n      top: -8px;\n  }\n\n}\n\n@media screen and (max-width:769px) {\n  .xdr-content-box{\n      width: 100%;\n  }\n  .xdr-row{\n      flex-direction: column;\n  }\n  .xdr-info p {\n      padding-top: 10px;\n      font-size: 12px;\n        padding-left: 0;\n  }\n  .xdr-info{\n      align-items: start;\n      flex-direction: column;\n    \n  }\n  .xdr-architecture p{\n      display: none;\n  } \n  .xdr-arc-icon{\n      margin-right: 0;\n  }\n  .user-betch {\n      right: -4px;\n      top: -8px;\n}\n}\n@media screen and (max-width:500px) {\n.main-pannel{\n      padding-bottom: 0;\n}\n\n.ham-menu {\n  display: flex !important;\n  width: 125px;\n  justify-content: space-evenly;\n}\n\n.admin-name{\n  display: none;\n}\n.admin-img{\n  margin: 0 10px;\n}\n.main{\n  flex-direction: column;\n}\n.sidebar-2{\n  display: none;\n}\n.setting{\n margin-bottom: 20px;\n}\n.main-pannel{\n  margin-left: 0;\n}\n.xdr-arc-icon{\n  margin-right:0;\n}\n.xdr-architecture p{\n  display: none;\n}\n.xdr-info{\n  flex-direction: column;\n}\n.coming-soon{\n  display: none;\n}\n.hamburger{\n  display: flex;\n}\n.sidebar-column{\n  padding-top: 20px;\n}\n\n.set-hamburger-btn{\n  display: flex !important;\n}\n\n.sidebar-1{\n  display: none;\n}\n\n#close{\n  display: none;\n}\n\n.xdr-content-text p{\n  width: 90%;\n}\n\n#set-close{\n  display: none;\n}\n}\n\n@media screen and (max-width:375px) {\n.admin-dd{\n  display: none;\n}\n}\n\n.ham-menu {\n  display: none;\n  width: 125px;\n  justify-content: space-evenly;\n}\n\n.set-hamburger-btn {\n  width: 50px;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  border-radius: 50%;\n  cursor: pointer;\n  display: none;\n}\n\n.logout-btn {\n  z-index: 100;\n  border-radius: var(--radius--r-40);\n  cursor: pointer;\n  background-color: #9de9b3;\n  justify-content: flex-start;\n  align-items: center;\n  margin-left: 24px;\n  margin-right: 24px;\n  padding: 5px;\n  display: none;\n  position: absolute;\n  top: auto;\n  bottom: -86px;\n  left: -32px;\n  right: -12px;\n}\n\n\n.card-row-1 {\n  margin-top: var(--padding--p-24);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  flex-flow: row;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-columns: 1fr;\n  grid-auto-flow: row;\n  align-items: stretch;\n  justify-items: stretch;\n  display: grid;\n}\n\n\n@media screen and (min-width: 1280px) {\n  .card-row-1 {\n      grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .card-row-1 {\n      grid-template-rows: auto auto;\n      grid-template-columns: 1fr 1fr;\n  }\n  .sidebar-column{\n    display: none;\n  } \n}\n\n@media screen and (max-width: 767px) {\n  .card-row-1 {\n      grid-template-rows: auto;\n      grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
